import { SILENT, createAction } from 'uix/actions';
export const setActiveLog = createAction('SET_ACTIVE_LOG', (active = {})=>({
        active
    }));
// connect to streaming /log3 server api and show ui
export const toggleLogStream = createAction('TOGGLE_LOG_STREAM', ({ channel, channelFilter, active, node } = {})=>({
        channel,
        channelFilter,
        active,
        node
    }));
// switch between dialog and panel mode
export const setLogStreamMode = createAction('SET_LOG_STREAM_MODE', (mode)=>({
        mode
    }));
export const setLogChannel = createAction('SET_LOG_CHANNEL', (channel)=>({
        channel
    }));
export const setLogStream = createAction('SET_LOG_STREAM', ({ on, channel, limit, streamidx, node })=>({
        on,
        channel,
        limit,
        streamidx,
        node
    }));
// receive new log data from /log3
export const setLogStreamData = createAction('LOG_STREAM_DATA', (lines)=>({
        lines
    }), SILENT);
